module.exports = __webpack_public_path__ + "img/WT63B0.f68efaa6.jpg";